import { render, staticRenderFns } from "./LmPagination.vue?vue&type=template&id=871833c2&scoped=true"
import script from "./LmPagination.vue?vue&type=script&lang=js"
export * from "./LmPagination.vue?vue&type=script&lang=js"
import style0 from "./LmPagination.vue?vue&type=style&index=0&id=871833c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871833c2",
  null
  
)

export default component.exports